export default function symposiumAuth ({ next, router }) {
  if (localStorage.getItem('symposium_token') === null) {
    console.log(window.location.pathname)
    if (router.currentRoute.path !== '/symposium/video/login') {
      return router.push('/symposium/video/login')
    }
  }

  return next()
}
